import right from '../../../assets/images/production/dataOpe/right.png'
import dataOpe from '../../../assets/images/production/dataOpe/dataOpe.png'
import leftBall from '../../../assets/images/production/dataOpe/left-ball.png'

import styles from './style.module.scss'

function DataOperationService() {
    return (
        <div className={`production-series-wrapper ${styles['data-ope-wrapper']}`}>
            <div className={`banner ${styles['banner']}`}>
                <div className="title">数据运营服务</div>
            </div>
            <div className={`series-container ${styles['series-container']}`}>
                <div className={`series-content ${styles['series-content']}`}>
                    <img src={leftBall} alt="" />
                    <div>
                        <div className={styles['series-left']}>
                            <div className={`introduction-title ${styles['introduction-title']}`}>
                                <div className={styles['title-container']}>
                                    <div>
                                        <p><span>数据运营服务</span></p>
                                        <p>烽火星空以实践经验为底，依托完整的数据治理体系，不断沉淀、优化，为用户提供数据应用全生命流程的运营管理服务，助力用户构建核心数据资产，精准赋能数据价值。</p>
                                        <p>以专业化的数据技术，分解从数据到服务的每一个步骤，将场景要素、资产价值、业务需要三元素紧密结合，推出专精的智能数字管理工具，高度匹配各行业领域客户需要，并且为用户配备定制化全周期运营服务，覆盖全国25+城市，帮助用户更快、更好、更专业地完成信息化、智能化、数字化建设工作。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles['series-right']}>
                            <img src={right} alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles['series-bottom']}>
                <img src={dataOpe} alt="" />
            </div>
        </div>
    )
}

export default DataOperationService